import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const JobListApi = createApi({
  reducerPath: "JobListApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_HOST,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getJobList: builder.mutation({
      query: (data) => ({
        url: "get/jobs/listing",
        method: "POST",
        body: data,
      }),
    }),
    getJob: builder.query({
      query: (id) => ({
        url: "get/jobs/" + id,
      }),
    }),
  }),
});

export const { useGetJobListMutation, useGetJobQuery } = JobListApi;
